import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=50b7a14c&scoped=true"
import script from "./UserDrawer.vue?vue&type=script&lang=js"
export * from "./UserDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserDrawer.vue?vue&type=style&index=0&id=50b7a14c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b7a14c",
  null
  
)

export default component.exports